/**!
 * Implements a <details-group> web component that can be
 * used to wrap multiple <details> elements allowing only
 * one child to be open at a time.
 */

class DetailsGroup extends HTMLElement {
  connectedCallback() {
    const scope = this
    const accordions = this.querySelectorAll("details")
    if (accordions.length) {
      accordions.forEach((accordion) => {
        const summary = accordion.querySelector("summary")
        if (summary) {
          summary.addEventListener("click", (event) => {
            const parentState = event.target.parentElement.open
            if (!parentState) {
              // const parentGroup = event.target.parentElement.parentElement
              const openItems = scope.querySelectorAll("details[open]")
              openItems.forEach((item) => {
                item.removeAttribute("open")
              })
            }
          })
        }
      })
    }
  }
  disconnectedCallback() {
    const summaries = this.querySelectorAll("summary")
    if (summaries.length) {
      summaries.forEach((summary) => {
        summary.removeEventListener("click", false)
      })
    }
  }
}
customElements.define("details-group", DetailsGroup)
